import React from 'react'

const Logo = () => {
  return (
    <div className="text-2xl font-bold pl-0 pr-10 lg:px-10">
      WeTube
    </div>
  )
}

export default Logo